import { useAuth, hasAuthParams } from 'react-oidc-context';
import LoadingSpinner from '../presetation/components/LoadingSpinner';
import { useEffect, useState } from "react"
import { Flex } from '@chakra-ui/react';

const PrivateRoute = ({ children }) => {
    const auth = useAuth();

    const [hasTriedSigning, setHasTriedSigning] = useState(false)

    useEffect(() => {
        const signInIfNecessary = async () => {
            try {
                if (
                    !hasAuthParams() &&
                    !auth.isAuthenticated &&
                    !auth.activeNavigator &&
                    !auth.isLoading &&
                    !hasTriedSigning
                ) {
                    await auth.signinRedirect()
                    setHasTriedSigning(true)
                }
            } catch (error) {
                console.error('Error during signinRedirect:', error)
            }
        }

        signInIfNecessary()
    }, [auth, hasTriedSigning])


    if (auth.isLoading) {
        return <Flex w="full" h="100vh" alignItems="center" justifyContent="center"><LoadingSpinner /></Flex>
    }

    if (!auth.isAuthenticated) {
        return <div />
    }

    if (auth.error) {
        return <div>Oops... {auth.error.message}</div>
    }

    return children;
};

export default PrivateRoute;